module.exports = __webpack_public_path__ + "static/media/amal.496cb6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/amal.png
// module id = 2264
// module chunks = 0